import { render, staticRenderFns } from "./UkraineDonationTerms.vue?vue&type=template&id=1452bd08&"
import script from "./UkraineDonationTerms.vue?vue&type=script&lang=js&"
export * from "./UkraineDonationTerms.vue?vue&type=script&lang=js&"
import style0 from "./UkraineDonationTerms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports